import { Permission } from 'api'
import React from 'react'
import { useSelector } from 'react-redux'
import { createPermissionsSelector } from 'selectors/permissionSelectors'
import { isAdminGatewayUserSelector } from 'selectors/userSelectors'

export const Permissioned: React.FC<{ oneOf: Permission[]; allowAdmin?: boolean; children: React.ReactElement }> = ({
  oneOf,
  allowAdmin = false,
  children
}) => {
  const isAdmin = useSelector(isAdminGatewayUserSelector)
  const hasPermission = useSelector(createPermissionsSelector(oneOf))
  const isEnabled = allowAdmin === true ? isAdmin || hasPermission : hasPermission
  return isEnabled ? children : null
}
